export default {
  website_tagging: 'mdi-web',
  advertising_snippet: 'mdi-advertisements',
  bug: 'mdi-bug',
  support: 'mdi-face-agent',
  adobe_analytics_account: 'mdi-badge-account-horizontal-outline',
  cid_value: 'mdi-account'
}
